import React, {useState} from "react";
import {USER_TYPE} from "../labels";

import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {Permission, PermissionRolEnum, ConfigUserRestControllerApiFactory, User,} from "arteco-api-client-ts";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Button, Grid, Typography} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {types} from "../../../../components/form/types";
import {H3, Typographies} from "../../../../components/utils/typography_consts";
import {useLocation, useNavigate} from "react-router-dom";
import {AxiosResponse} from "axios";

export const UserEditPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(ConfigUserRestControllerApiFactory);

    const [permissions, setPermissions] = useState<Permission[]>();
    const [permType, setPermType] = useState<PermissionRolEnum>();

    const form = useForm({
        fetcher: (id) =>
            ctrl.getUser(id).then((res: AxiosResponse<User>) => {
                setPermissions(res.data.permissions || []);
                return res;
            }),
        updater: (bean) => ctrl.saveUser(bean),
        remover: (id) => ctrl.deleteOrDismissUser(id),
        factory: () => {
            return {} as User;
        },
    } as UseFormProps<User>);

    return (
        <>
            <FormContent form={form} title={"Ficha de usuario"}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <FormInput field={"username"} label={"Nombre de usuario"}/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormInput type={"date"} field={"dismissed"} label={"Eliminado"}/>
                    </Grid>
                </Grid>

                <FormInput field={"email"} type={"email"} label={"Correo electrónico"}/>

                {permissions && (
                    <>
                        <Typography variant="subtitle1" component={H3} fontWeight={700} sx={{mt: 2, mb: 1}}>
                            Permisos del usuario
                        </Typography>
                        {permissions.map((permission, pIdx) => (
                            <Grid container spacing={3} key={pIdx}>
                                <Grid item xs={12} sm>
                                    {USER_TYPE[String(permission.rol || "").replace(/^ROLE_/, "")] ?? permission.rol}
                                </Grid>
                                <Grid item xs={12} sm>
                                    <Button
                                        variant={"outlined"}
                                        color={"error"}
                                        size={"small"}
                                        onClick={() => {
                                            if (
                                                permission.id &&
                                                confirm("¿Seguro que quieres quitar este permiso?")
                                            ) {
                                                apiManager
                                                    .execute(ctrl.deletePermissionUser(permission.id))
                                                    .then(() => navigate(location.pathname));
                                            }
                                        }}>
                                        Quitar
                                    </Button>
                                </Grid>
                            </Grid>
                        ))}
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm>
                                <FormSelect
                                    field={"permissionSelectRole"}
                                    label={"Rol"}
                                    type={types.userPermission}
                                    onChange={(item) => {
                                        setPermType(
                                            item
                                                ? (types.userTypes.valuer(
                                                    item
                                                ) as PermissionRolEnum)
                                                : undefined
                                        );
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm>
                                <Button
                                    variant={"contained"}
                                    style={{marginTop: "8px"}}
                                    size={"small"}
                                    onClick={() => {
                                        if (permType) {
                                            permissions.push({
                                                user: {id: form.getIdOrErr()} as User,
                                                rol: permType,
                                            } as Permission);
                                            form.save().then(() => navigate(location.pathname));
                                        }
                                    }}>
                                    Añadir
                                </Button>
                            </Grid>
                        </Grid>
                    </>
                )}
            </FormContent>
        </>
    );
};